import { render, staticRenderFns } from "./vodresetTutorial.vue?vue&type=template&id=729c1a8c&scoped=true&"
import script from "./vodresetTutorial.vue?vue&type=script&lang=js&"
export * from "./vodresetTutorial.vue?vue&type=script&lang=js&"
import style0 from "./vodresetTutorial.vue?vue&type=style&index=0&id=729c1a8c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729c1a8c",
  null
  
)

export default component.exports